.container {
  background-color: var(--color-grayscale-charleston);
  border-radius: 0.4rem;

  & > * {
    #collapsible-trigger {
      padding: 0.8rem;

      & > div:first-child {
        width: 100%;
      }

      & button {
        background-color: var(--color-grayscale-tuna);
      }
    }
  }
}

/* .cell-content and .cover-item are hook classes handed to CellContent and
   CoverItem, which are owned by other modules. CSS Modules cannot target
   another module's class, so this file tags the elements it needs to reach. */
.content-container {
  padding: 0 1.6rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  &[data-hidden='true'] {
    .cell-content {
      color: var(--color-grayscale-trout);
    }
  }
}

.shot-title {
  color: var(--color-grayscale-white);
  font-size: 1.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &[data-placeholder='true'] {
    display: block;
    color: var(--color-grayscale-light-slate);

    &:not(:only-child) {
      display: none;
    }
  }
}

.header {
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
  min-height: 3.2rem;

  & > :only-child {
    justify-content: center;
  }

  & .cover-item {
    min-width: 12rem;
  }
}

.header-data-wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 0.4rem;
  width: 100%;
  padding-inline-start: 0.8rem;

  &[data-hidden='true'] {
    .shot-title,
    .cell-content {
      color: var(--color-grayscale-trout);
    }
  }
}

.header-data {
  width: 100%;
}
